// Catálogo de Care Gap Status (grupo `care_gaps`)
export const CARE_GAP_STATUS = {
  OPEN:      { id: 53, key: "open",      name: "Open" },
  SUBMITTED: { id: 54, key: "submitted", name: "Submitted" },
  CLOSED:    { id: 55, key: "closed",    name: "Closed" },
};

export const CARE_GAP_STATUS_OPTIONS = [
  { id: 53, key: "open",      name: "Open" },
  { id: 54, key: "submitted", name: "Submitted" },
  { id: 55, key: "closed",    name: "Closed" },
];

// Workflow statuses: el catálogo YA NO se hardcodea. Se consulta del backend
// con getWorkflowStatuses() → GET /api/CareGapsV2/workflow-statuses, y se
// agrupa con el helper de abajo para los dropdowns. Los colores por workflow
// (WORKFLOW_STATUS_COLORS, más abajo) sí se quedan: son de presentación.

/**
 * Agrupa el catálogo de workflow statuses por `groupName`, ordenando los
 * grupos por `groupOrder` y las opciones por `displayOrder`. Devuelve una
 * lista plana con entradas { type: "header" } / { type: "option" }, lista
 * para renderizar en un Select con encabezados ListSubheader (mismo estilo
 * que el "Care Gap Actions" del módulo legacy).
 *
 * @param {Array<{statusId:number,statusName:string,groupName:string,groupOrder:number,displayOrder:number}>} workflowStatuses
 * @returns {Array<{type:"header",label:string}|{type:"option",value:number,label:string}>}
 */
export function buildGroupedWorkflowItems(workflowStatuses) {
  const list = Array.isArray(workflowStatuses) ? workflowStatuses : [];
  const groups = new Map();
  list.forEach((ws) => {
    const key = ws.groupName || "Other";
    if (!groups.has(key)) {
      groups.set(key, { groupOrder: ws.groupOrder ?? 999, items: [] });
    }
    groups.get(key).items.push(ws);
  });

  const out = [];
  [...groups.entries()]
    .sort((a, b) => a[1].groupOrder - b[1].groupOrder)
    .forEach(([groupName, { items }]) => {
      out.push({ type: "header", label: groupName });
      items
        .slice()
        .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        .forEach((ws) => {
          out.push({ type: "option", value: ws.statusId, label: ws.statusName });
        });
    });
  return out;
}

// Canales de outreach permitidos (validación en el modal)
export const OUTREACH_CHANNELS = [
  "Phone",
  "Text",
  "Email",
  "In person",
  "Lab order/Online Order",
];

// Resultados de outreach por defecto (canales de contacto directo).
export const OUTREACH_RESULTS = [
  "Contacted",
  "Voicemail",
  "No answer",
  "Wrong number",
  "Disconnected",
  "Refused",
  "Other",
];

// Resultados específicos por canal. Si un canal está en este mapa, el dropdown
// de "Result" usa estas opciones en lugar de OUTREACH_RESULTS.
export const OUTREACH_RESULTS_BY_CHANNEL = {
  "Lab order/Online Order": [
    "Cologuard was ordered online",
    "Quest order",
    "Stool Card Provided",
  ],
};

/**
 * Devuelve los Results válidos para un canal dado.
 * Si el canal tiene un override en OUTREACH_RESULTS_BY_CHANNEL, devuelve esa
 * lista; de lo contrario devuelve OUTREACH_RESULTS (default).
 */
export function getOutreachResultsForChannel(channel) {
  return OUTREACH_RESULTS_BY_CHANNEL[channel] || OUTREACH_RESULTS;
}

export const OUTREACH_NEXT_ACTIONS = [
  "Schedule appointment",
  "Call back later",
  "Send text reminder",
  "Send email",
  "No further action",
  "Other",
];

// Colores asociados al status (chip + borde de la card)
export const CARE_GAP_STATUS_COLORS = {
  open:      { bg: "#ffebee", border: "#e53935", text: "#c62828",   chip: "error"   },
  submitted: { bg: "#fff8e1", border: "#fb8c00", text: "#e65100",   chip: "warning" },
  closed:    { bg: "#e8f5e9", border: "#43a047", text: "#2e7d32",   chip: "success" },
};

// Colores por workflow más usado (los no listados → gris)
export const WORKFLOW_STATUS_COLORS = {
  new:              "#ef5350",
  pending:          "#ff9800",
  in_progress:      "#fb8c00",
  contact_attempt:  "#fdd835",
  contacted:        "#fdd835",
  voicemail:        "#fdd835",
  scheduled:        "#1e88e5",
  closed_availity:  "#43a047",
  refused:          "#9e9e9e",
  no_phone:         "#9e9e9e",
  language_barrier: "#9e9e9e",
  deceased:         "#757575",
  other:            "#9e9e9e",
};
